export default __webpack_public_path__ + "static/media/008-beer.6cfa6147.svg";